<script>
import { Doughnut } from "vue-chartjs";
export default {
  extends: Doughnut,
  data() {
    return {};
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      let datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [this.getRandomInt(), this.getRandomInt()]
          },
          {
            label: "Data One",
            backgroundColor: "#fc0171",
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      };
      this.renderChart(datacollection, this.options);
    },
    getRandomInt() {
      return Math.floor(Math.random() * 100);
    }
  }
};
</script>
